/**
 * https://iconscout.com/unicons/explore/line
 */
/**
 * Icons:
 *   https://icones.js.org/
 */
export { default as AngleRightIcon } from "@tento-ui/icons/angle-right.svg";
export { default as ArrowBackIcon } from "@tento-ui/icons/arrow-back.svg";
export { default as ArrowDownIcon } from "@tento-ui/icons/arrow-down.svg";
export { default as ArrowUpIcon } from "@tento-ui/icons/arrow-up.svg";
export { default as ArrowsAngleExpandIcon } from "@tento-ui/icons/arrows-angle-expand.svg";
export { default as CalendarIcon } from "@tento-ui/icons/calendar.svg";
export { default as ClockIcon } from "@tento-ui/icons/clock.svg";
export { default as ColumnsIcon } from "@tento-ui/icons/columns.svg";
export { default as CheckCircleFilledIcon } from "@tento-ui/icons/check-circle-filled.svg";
export { default as CheckmarkIcon } from "@tento-ui/icons/checkmark.svg";
export { default as ChevronDownIcon } from "@tento-ui/icons/chevron-down.svg";
export { default as ChevronRightIcon } from "@tento-ui/icons/chevron-right.svg";
export { default as ChevronUpIcon } from "@tento-ui/icons/chevron-up.svg";
export { default as CircleIcon } from "@tento-ui/icons/circle.svg";
export { default as ComponentIcon } from "@tento-ui/icons/component.svg";
export { default as DatabaseIcon } from "@tento-ui/icons/database.svg";
export { default as DragIcon } from "@tento-ui/icons/drag.svg";
export { default as EyeIcon } from "@tento-ui/icons/eye.svg";
export { default as EyeSlashedIcon } from "@tento-ui/icons/eye-slashed.svg";
export { default as FormulaIcon } from "@tento-ui/icons/formula.svg";
export { default as GearIcon } from "@tento-ui/icons/gear.svg";
export { default as GlobeIcon } from "@tento-ui/icons/globe.svg";
export { default as GridIcon } from "@tento-ui/icons/grid.svg";
export { default as JournalIcon } from "@tento-ui/icons/journal.svg";
export { default as HashIcon } from "@tento-ui/icons/hash.svg";
export { default as MenuIcon } from "@tento-ui/icons/menu.svg";
export { default as MoonIcon } from "@tento-ui/icons/moon.svg";
export { default as MoonFillIcon } from "@tento-ui/icons/bootstrap/moon-fill.svg";
export { default as NumberIcon } from "@tento-ui/icons/number.svg";
export { default as PencilIcon } from "@tento-ui/icons/pencil.svg";
export { default as PlusIcon } from "@tento-ui/icons/plus.svg";
export { default as SnapCenterIcon } from "@tento-ui/icons/snap-center.svg";
export { default as SnapLeftIcon } from "@tento-ui/icons/snap-left.svg";
export { default as TextIcon } from "@tento-ui/icons/text.svg";
export { default as Text2Icon } from "@tento-ui/icons/text2.svg";
export { default as ThreeDotsIcon } from "@tento-ui/icons/three-dots.svg";
export { default as TimelineColumnIcon } from "@tento-ui/icons/timeline-column.svg";
export { default as TimelineRowIcon } from "@tento-ui/icons/timeline-row.svg";
export { default as TrashIcon } from "@tento-ui/icons/trash.svg";
export { default as XIcon } from "@tento-ui/icons/x.svg";
export { default as ResetIcon } from "@tento-ui/icons/reset.svg";
export { default as StarIcon } from "@tento-ui/icons/star-outline.svg";
export { default as StarFilledIcon } from "@tento-ui/icons/star-filled.svg";
export { default as LoadingIcon } from "@tento-ui/icons/svg-spinners/3-dots-fade.svg";
export { default as ArrowsVerticalIcon } from "@tento-ui/icons/arrows-vertical.svg";
export { default as QuestionIcon } from "@tento-ui/icons/question.svg";
export { default as SearchIcon } from "@tento-ui/icons/search.svg";
export { default as SlashIcon } from "@tento-ui/icons/slash.svg";
export { default as ListNestedIcon } from "@tento-ui/icons/bootstrap/list-nested.svg";
export { default as ListUlIcon } from "@tento-ui/icons/list-ul.svg";
export { default as BarChartIcon } from "@tento-ui/icons/bootstrap/bar-chart.svg";

export { default as LinkIcon } from "@tento-ui/icons/iconoir/link.svg";
export { default as PlayIcon } from "@tento-ui/icons/iconoir/play.svg";
export { default as SparkleIcon } from "@tento-ui/icons/iconoir/sparkle.svg";
export { default as CheckSquareIcon } from "@tento-ui/icons/iconoir/check-square.svg";

export { default as ExpandIcon } from "@tento-ui/icons/material-symbols/expand.svg";
export { default as CollapseIcon } from "@tento-ui/icons/material-symbols/collapse.svg";
export { default as PencilFilledIcon } from "@tento-ui/icons/material-symbols/pencil-filled.svg";
export { default as CloudIcon } from "@tento-ui/icons/material-symbols/cloud.svg";

export { default as TextRight } from "@tento-ui/icons/bootstrap/text-left.svg";
export { default as TextLeft } from "@tento-ui/icons/bootstrap/text-right.svg";
export { default as TextCenter } from "@tento-ui/icons/bootstrap/text-center.svg";
export { default as WifiIcon } from "@tento-ui/icons/bootstrap/wifi.svg";
export { default as CardTextIcon } from "@tento-ui/icons/bootstrap/card-text.svg";
export { default as ShuffleIcon } from "@tento-ui/icons/bootstrap/shuffle.svg";

// Harness marks. Unlike every other icon here these carry their OWN fills
// (Claude's terracotta, OpenAI's green) rather than `currentColor` — they are
// brand marks, and the colour is the identity. `LonaIcons.make`'s `color`
// option is therefore inert on them, which is the intended behaviour.
export { default as ClaudeIcon } from "@tento-ui/icons/claude.svg";
export { default as OpenAiIcon } from "@tento-ui/icons/openai.svg";

// Empty icon for spacing in menus
export const EmptyIcon = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke=currentColor></svg>`;
// Minus / "_" glyph for minimize / dock buttons
export const MinusIcon = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M3 8h10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>`;
export const TEMP_CALENDAR_ICON = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M3 6.5V12.5C3 13.0523 3.44772 13.5 4 13.5H12C12.5523 13.5 13 13.0523 13 12.5V6.5M3 6.5V4C3 3.44772 3.44772 3 4 3H12C12.5523 3 13 3.44772 13 4V6.5M3 6.5H13M10 1.5V4.5M6 1.5V4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
